module.exports = __webpack_public_path__ + "static/media/icon-home-pb.f33fb7d3.png";